import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { ActionSheetController, Platform, ToastController , AlertController} from "ionic-angular";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { File } from "@ionic-native/file";
import { FilePath } from "@ionic-native/file-path";
//import { TransferObject } from "@ionic-native/transfer";
import firebase from 'firebase';
import { AngularFireDatabase } from 'angularfire2/database';
declare const Promise;

@Component({
  selector: 'multi-image-upload',
  templateUrl: 'multi-image-upload.html',
  providers: [Camera, File, FilePath, Platform]
})

export class MultiImageUpload {
  public isUploading = false;
  public uploadingProgress = {};
  public uploadingHandler = {};
  public images: any = [];
  protected imagesValue: Array<any> = new Array<any>();
  protected imageFiles: any = [];
  public index: number = 0;
  protected uploadFinished = false;
  public outputList: any = [];
  public outputstring: string;
  public removed: boolean = false;
  public selected: boolean = false;
  public buttonDisplayName: string = "";

  @Input()
  public uid: string;

  @Input()
  public items: any = [];

  @Input()
  public maxUploads: number = 1;

  @Input()
  public categoryName: string = 'logo';

  @Input()
  public buttonDispaly: string;

  @Input()
  public canpushdb: string = "true";

  @Input()
  public path: string = "";

  @Input()
  public storagePath: string;

  @Output()
  change: EventEmitter<string> = new EventEmitter<string>();

  constructor(private sanitization: DomSanitizer, private actionSheetCtrl: ActionSheetController, private camera: Camera, private toastCtrl: ToastController, public af: AngularFireDatabase, private file: File, private alertCtrl: AlertController) {

  }

  public uploadImages() {
    console.log('upload image function loading...');
    console.log(this.images);
    let catName = this.categoryName;
    if (!this.uid)
      this.uid = '4';
    let storageRef = this.storagePath && this.storagePath.length > 0 ? firebase.storage().ref(`${this.storagePath}/${this.uid}`) : firebase.storage().ref(`${this.uid}/${catName}`);
    var objToUpdate = 'restaurants/' + this.uid;
    var dataToSave = {}
    // this.af.object(objToUpdate).update(dataToSave)
    for (let i = 0; i < this.imageFiles.length; i++) {
      let filename = this.imageFiles[i].input == undefined ? Math.floor(Date.now() / 1000) + '.jpg' : this.imageFiles[i].input.files[0].name.replace(/[()]/g, '');

      this.fireUploadImage(storageRef, this.imageFiles[i].input == undefined ? this.imageFiles[i].blob : this.imageFiles[i].input.files[0], filename, this.imageFiles[i].input == undefined).then((response: any) => {
        console.log(response);

        if (i == 0)
          dataToSave[catName] = {}

        if (this.canpushdb == undefined || this.canpushdb == "true") {
          let imgref = this.af.list(objToUpdate + '/' + catName).push({ URL: response.downloadURL, imageName: response.metadata.name });
          console.log(imgref);
          this.outputstring = response.downloadURL;
          this.imageFiles[i].upload = true;
        }
        else {
          this.outputstring = response.downloadURL;
          this.change.emit(this.outputstring);
        }
        this.showToast('Image Upload Successfully');
      }, error => {
        console.log(error);
      });
    }

  }

  public fireUploadImage(storageRef, file, filename, isSaveString) {
    var imageRef = isSaveString ? storageRef.child(`${filename}`).putString(file, firebase.storage.StringFormat.DATA_URL) : storageRef.child(`${filename}`).put(file);
    return new Promise((resolve, reject) => {
      imageRef.on('state_changed', (_stateRef) => {

      }, error => {
        console.log(error)
        reject(error);
      },
        () => {
          console.log('Final Block')
          resolve(imageRef.snapshot);

        }
      )
    })

  }


  public abort() {
    if (!this.isUploading)
      return;
    this.isUploading = false;
    for (let key in this.uploadingHandler) {
      this.uploadingHandler[key].abort();
    }
  }

  // ======================================================================
  protected removeImage(image) {
    if (image.key) {
      var objToUpdate = 'restaurants/' + this.uid + '/' + this.categoryName + '/' + image.key;
      if (this.canpushdb != undefined && this.canpushdb != "true") {
        objToUpdate = this.path + this.uid + '/' + image.key;
        image.URL = ""
        this.af.object(objToUpdate).update(image);
        this.removed = true;
        return;
      }
      this.af.object(objToUpdate).remove();

      return;
    }

    if (this.isUploading)
      return;
    this.util.confirm("Are you sure to remove it?").then(value => {
      if (value) {
        this.util.removeFromArray(this.imageFiles, image);
      }
    });
  }

  protected showAddImage() {
    console.log('showimage function loading...');
    if (!window['cordova']) {
      let input = document.createElement('input');
      input.type = 'file';
      input.accept = "image/x-png,image/gif,image/jpeg";
      input.click();
      input.onchange = () => {

        let blob = window.URL.createObjectURL(input.files[0]);
        this.images.push(blob);
        this.selected = true;
        this.imageFiles.push({
          id: this.index, input: input, blob: blob, others: {
            url: blob,
            sanitized: this.sanitization.bypassSecurityTrustStyle("url(" + blob + ")")
          }
        });
        this.util.trustImages();
      }
    } else {
      new Promise((resolve, reject) => {
        let actionSheet = this.actionSheetCtrl.create({
          title: 'Add a photo',
          buttons: [
            {
              text: 'From photo library',
              handler: () => {
                resolve(this.camera.PictureSourceType.PHOTOLIBRARY);
              }
            },
            {
              text: 'From camera',
              handler: () => {
                resolve(this.camera.PictureSourceType.CAMERA);
              }
            },
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                reject();
              }
            }
          ]
        });
        actionSheet.present();
      }).then(sourceType => {
        if (!window['cordova'])
          return;
        let options: CameraOptions = {
          quality: 100,
          sourceType: sourceType as number,
          saveToPhotoAlbum: false,
          correctOrientation: true
        };
        this.camera.getPicture(options).then((imagePath) => {
          this.selected = true;
          let obj = {
            id: this.index, input: undefined, blob: 'data:image/jpeg;base64,' + imagePath, others: {
              url: 'data:image/jpeg;base64,' + imagePath,
              sanitized: this.sanitization.bypassSecurityTrustStyle("url(" + 'data:image/jpeg;base64,' + imagePath + ")")
            }
          };
          this.imageFiles.push(obj);
          this.images.push(obj);
          this.util.trustImages();
        });
      }).catch(() => {
      });
    }
  }


  private util = ((_this: any) => {
    return {
      removeFromArray<T>(array: Array<T>, item: T) {
        let index: number = array.indexOf(item);
        if (index !== -1) {
          array.splice(index, 1);
        }
      },
      confirm(text, title = '', yes = "Yes", no = "No") {
        return new Promise(
          (resolve) => {
            _this.alertCtrl.create({
              title: title,
              message: text,
              buttons: [
                {
                  text: no,
                  role: 'cancel',
                  handler: () => {
                    resolve(false);
                  }
                },
                {
                  text: yes,
                  handler: () => {
                    resolve(true);
                  }
                }
              ]
            }).present();
          }
        );
      },
      trustImages() {
        _this.imagesValue = _this.images.map(
          val => {
            console.log(val);
            return {
              url: val,
              sanitized: _this.sanitization.bypassSecurityTrustStyle("url(" + val + ")")
            }
          }
        );
        console.log(_this.imagesValue);
      },
      showToast(text: string) {
        _this.toastCtrl.create({
          message: text,
          duration: 5000,
          position: 'bottom'
        }).present();
      }
    }
  })(this);


  // submit method
  protected submit() {
    if (this.images.length == 0) {
      this.showToast('Please select at least 1 photo');
      return;
    }

    this.uploadImages();
  }
  // Cancel Method
  protected cancelUpload() {

  };
  // Toast Message
  protected showToast(text: string) {
    this.toastCtrl.create({
      message: text,
      duration: 5000,
      position: 'bottom'
    }).present();
  }

  ngOnInit() {
    //  console.log(this.buttonDispaly);
    this.buttonDisplayName = this.categoryName;
    if (this.buttonDispaly && this.buttonDispaly.length > 0) {
      this.buttonDisplayName = this.buttonDispaly;
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/multiimagesupload/multi-image-upload.ts